<template>
  <div class="appointTipDiv">
    <div class="logo">
      <img src="../assets/img/order_icon.png" alt="" width="45%" />
      <div class="desc1">预约成功</div>
      <div class="desc2">
        您提交的车辆预约信息均已成功保存。
      </div>
    </div>
    <div style="height: 130px;"></div>
    <div class="footer-cont2" style="background: #fff;">
      <van-button
        type="primary"
        block
        class="btnStyle1"
        @click="
          $router.push({
            path: '/rhwxAppointList',
            query: {
              time1: time1,
              time2: time2,
              keyword: keyword
            }
          })
        "
        >查看我的预约</van-button
      >
      <!-- <van-button block class="btnStyle2">关闭</van-button> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tag: false
    };
  },
  created() {},
  methods: {},
  computed: {
    time1() {
      return this.$route.query.time1;
    },
    time2() {
      return this.$route.query.time2;
    },
    keyword() {
      return this.$route.query.keyword;
    }
  }
};
</script>
<style lang="less">
@import "../assets/css/common";
.appointTipDiv {
  font-size: 16px;
  .logo {
    text-align: center;
    padding: 42px 27px 36px;
  }
  .desc1 {
    font-size: 20px;
    color: #009967;
    margin-top: 10px;
  }
  .desc2 {
    font-size: 17px;
    color: #999;
    margin-top: 13px;
  }
  .btn {
    padding: 22px 0px 30px;
  }
  .divide {
    opacity: 0.8;
    &-line {
      height: 16px;
      width: 4px;
      background: #009967;
      display: inline-block;
      vertical-align: text-top;
    }
  }
}
</style>
